import React from 'react';
import { useGlobalContext } from '../../../../../../stores/global';
import { logout } from '../../../../../../helpers/asyncActions';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import LogoIcon from '../../../../../../images/icons/logo_icon.svg';
import NavItem from './components/NavItem';
import { Link } from 'react-router-dom';

const SidebarNav = ({ pages }: any) => {
  const { user, dispatch } = useGlobalContext();

  const {
    secondary: secondaryPages,
    company: companyPages,
    account: accountPages,
    subscription: subscriptionInfo,
  } = pages;

  return (
    <Box>
      <Box width={1} paddingX={2} paddingY={1}>
        <Box
          display={'flex'}
          component="a"
          href="/"
          title="Hauscanner"
          width={{ xs: 100, md: 120 }}
        >
          <Box component={'img'} src={LogoIcon} height={1} width={0.34} />
        </Box>
      </Box>
      <Box paddingX={2} paddingY={2}>
      <Box>
          <NavItem title={'Explora propiedades'} items={secondaryPages} />
        </Box>
        <Box>
          <NavItem title={'¿Cómo funciona?'} items={companyPages} />
        </Box>
        <Box>
          <NavItem title={'Mi suscripción'} items={subscriptionInfo} />
        </Box>
        <Box>
          <NavItem title={'Mi perfil'} items={accountPages} />
        </Box>
        {user?.name ? (
                  <Box marginTop={2}>
                  <Button
                    size={'large'}
                    variant="outlined"
                    fullWidth
                    onClick={() => logout(dispatch) }
                  >
                    Cerrar sesión
                  </Button>
                </Box>
        ): (
          <Box marginTop={2}>
          <Button
            size={'large'}
            variant="outlined"
            fullWidth
            onClick={() =>
              dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' })
            }
          >
            Inicia sesión
          </Button>
        </Box>
        )}
        <Box marginTop={1}>
          <Button
            size={'large'}
            variant="contained"
            color="primary"
            fullWidth
            component={Link}
            to="/properties"
          >
            Busca tu propiedad
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarNav;
